module.exports = () => ({
    'total': 0,
    'count': 0,
    'per_page': 0,
    'current_page': 1,
    'total_pages': 1,
    'links': []
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/default-pagination.js